<template>
    <form class="p-6 bg-white border border-gray-200 sm:rounded-lg">
        <h3 class="font-semibold text-xl text-center text-gray-800 sm:leading-tight">
            Two-Factor Authentication
        </h3>
        <img :src="route('2fa.generate')" alt="qr code 2FA" class="mx-auto">

        <div class="mt-4">
            <Label for="re-password" value="Confirm new password" />
            <Input
                id="re-password"
                type="password"
                class="mt-1 block w-full"
                v-model="form.secret"
                required
                autocomplete="off"
            />
            <InputError :message="form.errors.secret"/>
        </div>
        <div class="flex items-center justify-end mt-4">
            <div class="my-auto font-medium text-sm text-green-600">
                {{ status }}
            </div>
            <Button class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Change
            </Button>
        </div>
    </form>
</template>

<script>
import {useForm} from '@inertiajs/inertia-vue3';
import Button from "@/Components/Button";
import Input from "@/Components/Input";
import InputError from "@/Components/InputError";
import Label from "@/Components/Label";

export default {
    components: {
        Button,
        Input,
        InputError,
        Label,
    },
    setup () {
        const form = useForm({
            secret: '',
        })
        return {form}
    },
    computed: {
        status() {
            return this.$page.props.status && this.$page.props.status.TwoFA ? this.$page.props.status.TwoFA : '' ;
        },
    },
    methods: {
        submit() {
            this.form.post(this.route('settings.check2fa'), {
                preserveScroll: true,
                onSuccess: () => this.form.reset('secret'),
            })
        }
    }
}
</script>
